import { Alert as MuiAlert, Snackbar } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import AlertTitle from '@mui/material/AlertTitle'
import { useTheme } from '@mui/material/styles'

import { AdminUITheme } from 'types/AdminUiThemeMui'
import { RootState } from 'redux/store'
import { hideAlert, showAlert as showAlertAction } from 'redux/slices/Alert'
import { Alert as AlertType } from 'types/Alert'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { handleCustomIconForInfo } from 'components/Shared/Alert/Helper'

const Alert = () => {
  const {
    alert: { show, title = '', message, type, isHTML, icon = '' },
  } = useAppSelector((state: RootState) => state)
  const dispatch = useAppDispatch()

  const handleClose = () => {
    dispatch(hideAlert())
  }

  const theme: AdminUITheme = useTheme()

  const CustomAlertTitle = () => {
    if (isHTML) {
      return <AlertTitle dangerouslySetInnerHTML={{ __html: title }} />
    }
    return <AlertTitle>{title}</AlertTitle>
  }

  return (
    <Snackbar
      open={show}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <MuiAlert
        severity={type}
        sx={theme.ParticipantGrid.paddingBottomZero}
        variant="filled"
        iconMapping={{
          success: <CheckCircleOutlineIcon fontSize="inherit" />,
          info: handleCustomIconForInfo(icon),
        }}
      >
        <CustomAlertTitle />
        {message ? <span>{message}</span> : null}
      </MuiAlert>
    </Snackbar>
  )
}

export const useAlert = () => {
  const dispatch = useAppDispatch()

  const showAlert = (info: AlertType) => dispatch(showAlertAction(info))

  return {
    showAlert,
  }
}

export default Alert
